import Hammer from 'hammerjs';
window.hammer = Hammer